import {inject, Injectable} from '@angular/core';
import {ProjectDTO} from '../../modules/project/dto/project';
import {DeviceIdService} from './device-id.service';
import {Store} from '@ngrx/store';
import {selectProjectById} from '../../modules/project/service/project.selectors';
import {map} from 'rxjs/operators';
import {of} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ProjectPermissionService {
  private readonly deviceIdService: DeviceIdService = inject(DeviceIdService);
  private readonly store: Store = inject(Store);

  hasWritePermission(project?: ProjectDTO) {
    if(!project) {
      return false;
    }
    const isCorrectUser = project.keycloakId == this.deviceIdService.getDeviceId();
    if(isCorrectUser) {
      return isCorrectUser;
    }
    return !project.keycloakId && !project.exploringMode
  }

  hasWritePermissionViaStore(projectId?: number) {
    if(!projectId) {
      return of(true);
    }
    return this.store.select(selectProjectById(projectId)).pipe(
      map(result => {
        if(!result) {
          return false;
        }
        return this.hasWritePermission(result);
      }),
    )
  }


}
